import styled, { css } from 'styled-components';
import AjaxSpinner from '@/components/AjaxSpinner';

const Input = css`
  background: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;

  padding: 8px;

  font-weight: 400;
  font-size: 14px;

  color: #061e2d;
`;

export const ContentWrapper = styled.div`
  margin: auto;
  padding-top: 50px;
  width: fit-content;
`;

export const PageLoading = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackButton = styled.div`
  font-weight: 400;
  font-size: 13px;
  display: flex;
  align-items: center;

  cursor: pointer;
`;

export const ViewTitle = styled.h1`
  font-style: normal;
  font-weight: 700;
  font-size: 25px;
  line-height: 28px;
  margin-top: 20px;
  margin-bottom: 18px;

  color: #000;
`;

export const Label = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 23px;

  color: #000;
`;

export const CommentInput = styled.textarea`
  ${Input};
  min-width: 400px;
  min-height: 100px;

  margin-top: 18px;
  margin-bottom: 35px;
`;

export const ConfirmInput = styled.input`
  min-width: 500px;
  height: 45px;

  margin-top: 8px;
  margin-bottom: 40px;
  ${Input}
`;

export const ButtonAjaxSpinner = styled(AjaxSpinner)`
  width: 16px !important;
  height: 16px !important;
  transform: translate(0px, -8px) scale(0.28) translate(0px, 0px);
`;

export const CancelSubscriptionButton = styled.button<{
  isLoading: boolean;
}>`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  padding: 8px 32px;

  height: 50px;

  background: #ba2c2c;

  border: 2px solid #ba2c2c;
  border-radius: 34px;

  width: fit-content;

  font-weight: 700;
  font-size: 16px;
  margin-bottom: 10px;

  color: #ffffff;
  ${(p) =>
    (p.isLoading || p.disabled) &&
    css`
      opacity: 0.5;
    `}
`;
